import { useState } from "react";

export const useMenuCollapsedBehavior = () => {
  const [collapsed, setCollapsed] = useState(true);

  return {
    collapsed,
    setCollapsed,
  };
};
